/**
 * İyzico Hata Kodları ve Türkçe Açıklamaları
 */

export const IYZICO_ERROR_CODES = {
    // Genel Hatalar
    '1': 'Genel hata - Lütfen tekrar deneyin',
    '2': 'Kart sahibi bankadan onay almadı',
    '3': 'Geçersiz üye işyeri',
    '5': 'İşlem onaylanmadı',
    '12': 'Geçersiz işlem',
    '13': 'Geçersiz tutar',
    '14': 'Geçersiz kart numarası',
    '15': 'Geçersiz banka',
    '19': 'Tekrar deneyin',
    '25': 'Kayıt bulunamadı',
    '28': 'Dosya geçici olarak kullanılamıyor',
    '30': 'Mesaj formatı hatası',
    '33': 'Kartın geçerlilik süresi dolmuş',
    '34': 'Dolandırıcılık şüphesi',
    '36': 'Kısıtlı kart',
    '37': 'Güvenlik ihlali - Bankayı arayın',
    '38': 'İzin verilen PIN deneme sayısı aşıldı',
    '41': 'Kayıp kart',
    '43': 'Çalıntı kart',
    '51': 'Yetersiz bakiye',
    '53': 'Hesap bulunamadı',
    '54': 'Kartın geçerlilik süresi dolmuş',
    '55': 'Hatalı PIN',
    '56': 'Kart tanımlı değil',
    '57': 'Kart sahibine kapalı işlem',
    '58': 'Terminale kapalı işlem',
    '59': 'Dolandırıcılık şüphesi',
    '61': 'Para çekme limiti aşıldı',
    '62': 'Kısıtlı kart',
    '63': 'Güvenlik ihlali',
    '65': 'Günlük işlem adedi limiti aşıldı',
    '75': 'İzin verilen PIN deneme sayısı aşıldı',
    '76': 'İşlem reddedildi - Hatalı CVV',
    '77': 'Tutarsız veri',
    '78': 'Geçerli kart değil',
    '79': 'İşlem reddedildi',
    '80': 'İşlem tarih bilgisi hatalı',
    '81': 'PIN bloke',
    '82': 'CVV hatalı',
    '83': 'Doğrulama yapılamadı',
    '85': 'Kart onaylandı',
    '86': 'PIN doğrulaması yapılamadı',
    '87': 'Satın alma kodu yanlış',
    '89': 'Terminal ID hatalı',
    '91': 'Banka sistemi uygun değil',
    '92': 'Banka bulunamadı',
    '93': 'İşlem tekrarlandı',
    '96': 'Banka sistemi hatası',
    
    // Özel İyzico Hataları
    '10000': 'İyzico genel hatası',
    '10001': 'İyzico sistemleri kullanılamıyor',
    '10002': 'API isteği geçersiz',
    '10003': 'İyzico servis hatası',
    '50001': 'İstek formatı hatalı - Eksik veya geçersiz bilgi',
    '50002': 'Kimlik doğrulama hatası - API key hatalı',
    '50003': 'Yetkilendirme hatası',
    '50004': 'İstek zaman aşımına uğradı',
    
    // 3D Secure Hataları
    '20001': '3D Secure doğrulama başarısız',
    '20002': '3D Secure zaman aşımı',
    '20003': 'Kart 3D Secure için tanımlı değil',
    
    // Fraud (Dolandırıcılık) Kontrolleri
    '30001': 'Fraud kontrolü başarısız',
    '30002': 'Risk skorunuz yüksek',
    '30003': 'Kart kara listede',
    '30004': 'IP adresi şüpheli'
};

/**
 * Hata koduna göre Türkçe açıklama döndürür
 * @param {string|number} errorCode - İyzico hata kodu
 * @returns {string} - Türkçe açıklama
 */
export const getErrorDescription = (errorCode) => {
    if (!errorCode) return 'Bilinmeyen hata';
    
    const code = String(errorCode);
    return IYZICO_ERROR_CODES[code] || `Hata kodu: ${code} - Bilinmeyen hata`;
};

/**
 * Hata koduna göre kategori döndürür
 * @param {string|number} errorCode 
 * @returns {string} - Hata kategorisi
 */
export const getErrorCategory = (errorCode) => {
    if (!errorCode) return 'unknown';
    
    const code = String(errorCode);
    
    if (['41', '43'].includes(code)) return 'stolen';
    if (['51'].includes(code)) return 'insufficient_funds';
    if (['33', '54'].includes(code)) return 'expired';
    if (['55', '75', '81', '82', '86'].includes(code)) return 'invalid_pin_cvv';
    if (['34', '59', '30001', '30002', '30003', '30004'].includes(code)) return 'fraud';
    if (code.startsWith('5000')) return 'api_error';
    if (code.startsWith('2000')) return '3dsecure';
    if (['2', '5', '12', '19', '79'].includes(code)) return 'declined';
    
    return 'other';
};

/**
 * Hata kategorisine göre renk döndürür (Tailwind CSS)
 */
export const getErrorCategoryColor = (category) => {
    const colors = {
        'stolen': 'bg-red-900 text-white',
        'fraud': 'bg-red-800 text-white',
        'insufficient_funds': 'bg-orange-600 text-white',
        'expired': 'bg-yellow-600 text-white',
        'invalid_pin_cvv': 'bg-orange-500 text-white',
        '3dsecure': 'bg-purple-600 text-white',
        'api_error': 'bg-blue-600 text-white',
        'declined': 'bg-gray-600 text-white',
        'other': 'bg-gray-500 text-white'
    };
    
    return colors[category] || colors.other;
};

/**
 * Hata kategorisine göre ikon döndürür
 */
export const getErrorCategoryIcon = (category) => {
    const icons = {
        'stolen': '🚨',
        'fraud': '⚠️',
        'insufficient_funds': '💳',
        'expired': '📅',
        'invalid_pin_cvv': '🔒',
        '3dsecure': '🔐',
        'api_error': '⚙️',
        'declined': '❌',
        'other': '❗'
    };
    
    return icons[category] || icons.other;
};
